// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-f57b6f98] .van-dialog__header{font-weight:700!important;font-size:4.267vw!important}[data-v-f57b6f98] .van-cell-group{margin:0!important}[data-v-f57b6f98] .van-field{background:rgba(0,0,0,.03)!important;border-radius:1.067vw!important}[data-v-f57b6f98] .van-field:last-child{margin-top:3.2vw}[data-v-f57b6f98] .van-field__label{max-width:18.667vw}.input_width[data-v-f57b6f98] .van-field__label{width:12vw}", ""]);
// Exports
module.exports = exports;
